'use client';

import { useContext, useEffect } from 'react';
import { NavbarModeContext } from 'components/global/global-navigation/navbar-mode-context';
import Error from '../error';

export default function HomepageError(
	props: React.ComponentProps<typeof Error>,
) {
	const { setMode } = useContext(NavbarModeContext);

	useEffect(() => {
		setMode('inline');

		return () => setMode('overlay');
	}, [setMode]);

	return <Error {...props} />;
}
